import { useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import authSession from '@/utils/authSession';
import { getRequestErrorMessage } from '@/utils/requestError';

// 防止重复提交；离开页面或切换认证会话后，不再应用旧操作的结果。
const usePrivateAction = () => {
  const [busy, setBusy] = useState(false);
  const locked = useRef(false);
  const alive = useRef(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const run = async (operation, onSuccess, fallback = '操作失败，请重试') => {
    if (locked.current) return false;
    locked.current = true; setBusy(true);
    const generation = authSession.getGeneration();
    const active = () => alive.current && generation === authSession.getGeneration();
    try {
      const result = await operation();
      if (!active()) return false;
      await onSuccess?.(result);
      return true;
    } catch (error) {
      if (active()) message.error(typeof fallback === 'function' ? fallback(error) : getRequestErrorMessage(error, fallback));
      return false;
    } finally {
      locked.current = false;
      if (alive.current) setBusy(false);
    }
  };
  return { busy, run };
};
export default usePrivateAction;
